export default "__VITE_ASSET__Cu9FsM51__"